import { Forma } from 'forma-embedded-view-sdk/auto';
import * as THREE from 'three';

export const captureScreenshot = async ({
	canvasRef,
	rendererRef,
	sceneRef,
	cameraRef
}: {
	canvasRef: React.MutableRefObject<HTMLCanvasElement | null>;
	rendererRef: React.MutableRefObject<THREE.WebGLRenderer | null>;
	sceneRef: React.MutableRefObject<THREE.Scene | null>;
	cameraRef: React.MutableRefObject<THREE.Camera | null>;
}) => {
	if (!canvasRef.current || !rendererRef.current || !sceneRef.current || !cameraRef.current) {
		console.error('Canvas, renderer, scene, or camera reference is null');
		return;
	}
	const project = await Forma.project.get();

	const generateScreenshotName = () => {
		if (project) {
			return `BioScore_${project.name}_${project.hubId}_${new Date().toISOString()}.png`;
		}

		return `BioScore_screenshot_${new Date().toISOString()}.png`;
	}

	const canvas = canvasRef.current;
	rendererRef.current.render(sceneRef.current!, cameraRef.current!);

	const dataURL = canvas.toDataURL('image/png');
	const link = document.createElement('a');
	link.href = dataURL;
	link.download = generateScreenshotName();
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
